var render = function (_h,_vm) {var _c=_vm._c;return _c('b-img',{staticStyle:{"width":"0.65rem","height":"1rem","color":"white"},attrs:{"src":_vm.props.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }